import { API } from "aws-amplify"
import {getErrorMessage} from "../stores/StoreUtilities";
import Logger from "../components/Logger";

class AuthAPI {

  getAlias = async (alias: string) => {
    try {
      const response = await API.get("AuthAPI", `/alias/${alias}`, {})
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("AuthAPI.getAlias error", message)
      throw new Error(message)
    }
  }

  putUser = async (username: string, params: any)=> {
    try {
      const init = {
        body: {
          UserAttributes: [
            {Name: "email_verified", Value: "true"}
          ]
        }
      }
      const response = await API.put("AuthAPI", `/user/${username}`, init)
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("AuthAPI.putUser error", message)
      throw new Error(message)
    }
  }

  deleteUser = async (username: string) => {
    try {
      const response = await API.del("AuthAPI", `/user/${username}`, {})
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("AuthAPI.deleteUser error", message)
      throw new Error(message)
    }
  }

}
export default AuthAPI